export interface MockDemo {
  a: Function;
}

/** 拍摄状态  1：拍摄中  2：拍摄结束 */
export enum TaskStatus {
  /** 未拍摄 */
  NOT_FILMED = 0,
  /** 拍摄中 */
  DURING = 1,
  /** 拍摄结束 */
  COMPLETED = 2,
}

/** 分析状态枚举 */
export enum AnaStatus {
  /** 拍摄中/待分析 */
  DURING_FILMING = 1,
  /** 分析中 */
  ANALYZING= 2,
  /** 已分析 */
  ANALYSIS_COMPLETED= 3,
}

// 模拟特殊场景
export const demoData = [
  {
    'name': '2024-07-08',
    'points': [
      {
        'name': '11:00-11:30',
        'value': '0'
      },
      {
        'name': '11:30-12:00',
        'value': '0'
      },
      {
        'name': '12:00-12:30',
        'value': '0'
      },
      {
        'name': '12:30-13:00',
        'value': '0'
      }
    ]
  },
  {
    'name': '2024-06-14',
    'points': [
      {
        'name': '12:18-12:30',
        'value': '10'
      },
      {
        'name': '12:30-13:00',
        'value': '10'
      },
      {
        'name': '13:00-13:30',
        'value': '10'
      },
      {
        'name': '13:30-14:00',
        'value': '10'
      },
      {
        'name': '14:00-14:30',
        'value': '10'
      },
      {
        'name': '14:30-15:00',
        'value': '10'
      },
      {
        'name': '15:20-15:30',
        'value': '10'
      },
      {
        'name': '15:00-15:30',
        'value': '10'
      },
      {
        'name': '15:30-16:00',
        'value': '10'
      },
      {
        'name': '15:30-16:00',
        'value': '10'
      },
      {
        'name': '16:00-16:30',
        'value': '10'
      },
      {
        'name': '16:00-16:30',
        'value': '10'
      },
      {
        'name': '16:30-17:00',
        'value': '10'
      },
      {
        'name': '16:30-17:00',
        'value': '10'
      },
      {
        'name': '17:00-17:30',
        'value': '10'
      },
      {
        'name': '17:00-17:30',
        'value': '10'
      },
      {
        'name': '17:30-18:00',
        'value': '10'
      },
      {
        'name': '17:30-18:00',
        'value': '10'
      },
      {
        'name': '18:00-18:30',
        'value': '10'
      },
      {
        'name': '18:00-18:30',
        'value': '10'
      },
      {
        'name': '18:30-19:00',
        'value': '10'
      },
      {
        'name': '18:30-19:00',
        'value': '10'
      },
      {
        'name': '19:00-19:30',
        'value': '10'
      },
      {
        'name': '19:00-19:30',
        'value': '10'
      },
      {
        'name': '19:30-20:00',
        'value': '10'
      },
      {
        'name': '19:30-20:00',
        'value': '10'
      },
      {
        'name': '20:00-20:30',
        'value': '10'
      },
      {
        'name': '20:00-20:30',
        'value': '10'
      },
      {
        'name': '20:30-21:00',
        'value': '10'
      },
      {
        'name': '20:30-21:00',
        'value': '10'
      },
      {
        'name': '21:00-21:30',
        'value': '10'
      },
      {
        'name': '21:00-21:30',
        'value': '10'
      },
      {
        'name': '21:30-22:00',
        'value': '10'
      },
      {
        'name': '21:30-22:00',
        'value': '10'
      },
      {
        'name': '22:00-22:30',
        'value': '10'
      },
      {
        'name': '22:00-22:30',
        'value': '10'
      },
      {
        'name': '22:30-23:00',
        'value': '10'
      },
      {
        'name': '22:30-23:00',
        'value': '10'
      },
      {
        'name': '23:00-23:30',
        'value': '10'
      },
      {
        'name': '23:00-23:30',
        'value': '10'
      },
      {
        'name': '23:30-23:59',
        'value': '10'
      },
      {
        'name': '23:30-23:59',
        'value': '10'
      }
    ]
  },
  {
    'name': '2024-07-08',
    'points': [
      {
        'name': '15:00-15:30',
        'value': '120'
      },
      {
        'name': '15:30-16:00',
        'value': '220'
      },
      {
        'name': '16:00-16:30',
        'value': '320'
      },
      {
        'name': '16:30-17:00',
        'value': '420'
      }
    ]
  },
  {
    'name': '2024-06-14',
    'points': [
      {
        'name': '12:18-12:30',
        'value': '120'
      },
      {
        'name': '12:30-13:00',
        'value': '120'
      },
      {
        'name': '13:00-13:30',
        'value': '140'
      },
      {
        'name': '13:30-14:00',
        'value': '160'
      },
      {
        'name': '14:00-14:30',
        'value': '210'
      },
      {
        'name': '14:30-15:00',
        'value': '213'
      },
      {
        'name': '15:20-15:30',
        'value': '310'
      },
      {
        'name': '15:00-15:30',
        'value': '230'
      },
      {
        'name': '15:30-16:00',
        'value': '510'
      },
      {
        'name': '15:30-16:00',
        'value': '310'
      },
      {
        'name': '16:00-16:30',
        'value': '710'
      },
      {
        'name': '16:00-16:30',
        'value': '810'
      },
      {
        'name': '16:30-17:00',
        'value': '110'
      },
      {
        'name': '16:30-17:00',
        'value': '210'
      },
      {
        'name': '17:00-17:30',
        'value': '130'
      },
      {
        'name': '17:00-17:30',
        'value': '103'
      },
      {
        'name': '17:30-18:00',
        'value': '104'
      },
      {
        'name': '17:30-18:00',
        'value': '106'
      },
      {
        'name': '18:00-18:30',
        'value': '107'
      },
      {
        'name': '18:00-18:30',
        'value': '100'
      },
      {
        'name': '18:30-19:00',
        'value': '120'
      },
      {
        'name': '18:30-19:00',
        'value': '130'
      },
      {
        'name': '19:00-19:30',
        'value': '140'
      },
      {
        'name': '19:00-19:30',
        'value': '136'
      },
      {
        'name': '19:30-20:00',
        'value': '10'
      },
      {
        'name': '19:30-20:00',
        'value': '10'
      },
      {
        'name': '20:00-20:30',
        'value': '10'
      },
      {
        'name': '20:00-20:30',
        'value': '10'
      },
      {
        'name': '20:30-21:00',
        'value': '10'
      },
      {
        'name': '20:30-21:00',
        'value': '10'
      },
      {
        'name': '21:00-21:30',
        'value': '10'
      },
      {
        'name': '21:00-21:30',
        'value': '10'
      },
      {
        'name': '21:30-22:00',
        'value': '10'
      },
      {
        'name': '21:30-22:00',
        'value': '10'
      },
      {
        'name': '22:00-22:30',
        'value': '10'
      },
      {
        'name': '22:00-22:30',
        'value': '10'
      },
      {
        'name': '22:30-23:00',
        'value': '10'
      },
      {
        'name': '22:30-23:00',
        'value': '10'
      },
      {
        'name': '23:00-23:30',
        'value': '10'
      },
      {
        'name': '23:00-23:30',
        'value': '10'
      },
      {
        'name': '23:30-23:59',
        'value': '10'
      },
      {
        'name': '23:30-23:59',
        'value': '10'
      }
    ]
  },
];
